import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {ApolloClient, InMemoryCache} from '@apollo/client';
import {ApolloProvider} from '@apollo/client/react';
import {createHttpLink} from '@apollo/client/link/http';
import App from './App';
import reportWebVitals from './reportWebVitals';


import { setContext } from '@apollo/client/link/context';
import keycloak from "./Keycloak";

const httpLink = createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_URL,
    // TODO: Should I add this? CORS if f-ed up, and this one of the suggested fixes, but it doesn't work.
    // fetchOptions: {
    //     mode: 'no-cors'
    // },
});

const authLink = setContext(async (_, { headers }) => {
    let token = null;

    if (keycloak.authenticated) {
        const isTokenExpired = !keycloak.token || keycloak.isTokenExpired(30);

        if (isTokenExpired) {
            try {
                await keycloak.updateToken(30);
            } catch (error) {
                console.error('Failed to refresh token:', error);
                token = null;
            }
        }

        token = keycloak.token;
    } else {
        token = localStorage.getItem('token');
        if (token === 'undefined' || token === 'null' || token === '') {
            token = null;
        }
    }

    const bearer_token = token ? `Bearer ${token}` : "";

    return  {
        headers: {
            ...headers,
            authorization: bearer_token,
        }
    };
});

const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    connectToDevTools: process.env.NODE_ENV !== 'production'
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode> // TODO: Re-enable this!!
    <ApolloProvider client={client}>
    <App />
    </ApolloProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
